
import { useState } from 'react';
import { IdealProfile, DashboardState } from '@/types/dashboardTypes';

export const useDashboardState = () => {
  const [activeTab, setActiveTab] = useState('behavioral');
  const [filtersExpanded, setFiltersExpanded] = useState(false);
  const [tableExpanded, setTableExpanded] = useState(false);
  const [selectedIdealProfile, setSelectedIdealProfile] = useState<IdealProfile | null>(null);

  const handleToggleTable = () => {
    setTableExpanded(!tableExpanded);
  };

  const handleToggleFilters = () => {
    setFiltersExpanded(!filtersExpanded);
  };

  return {
    activeTab,
    setActiveTab,
    filtersExpanded,
    setFiltersExpanded,
    tableExpanded,
    setTableExpanded,
    selectedIdealProfile,
    setSelectedIdealProfile,
    handleToggleTable,
    handleToggleFilters
  };
};
